import { filemanagerService } from '../_config';

export const filemanagerUrls = {
    findFiles: filemanagerService + '/file',
    previewFile: filemanagerService + '/file/preview'
};
